import React , {Component} from 'react'
import '../assets/css/style.css'
export default  class En extends Component{
  render(){
    return(

             <div>
        <title>GAMEX l’expert après sinistre en transport</title>
        <div className="top_nav">
          <div className="container">
            {/*<span className="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target=".login_modal">Connexion</span>*/}
            <a href="/accident-recovery-expert" className="btn btn-primary btn-sm  pull-right">EN</a>  
          </div></div>  
        <header id="header">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-8 ">
                <h1 className="fr">
                  <span>ensemble</span><span>tout devient</span><span>beaucoup plus simple</span>
                </h1>
                {/*<a href="#pourquoi_gamex" class="btn btn-primary">Découvrez Gamex</a>*/}
                <a href="/expert-en-sinistre/contact" className="btn btn-primary btn-lg hidden-xs">Contactez-nous</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contactez-nous</a>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-4 ">
                <img className="img-responsive logo" src="img/gamex_sinistre_fr.png" alt="GAMEX l’expert après sinistre en transport" />
              </div>
            </div>
          </div>
        </header>
        <div className="scroller_anchor" />
        <nav id="navigation" className="scroller">
          <ul className="nav">
            <li id="accueil" className="col-md-2 col-sm-3 col-xs-3"><a href="#header">Accueil</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3 "><a href="#gamex_plus">Qui sommes-nous ?</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="#pourquoi_gamex">Expertise</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/expert-en-sinistre/contact">Nous joindre</a></li>
          </ul>
          <div className="col-md-2 hidden-sm hidden-xs" />
          <div className="col-md-2 hidden-sm hidden-xs" />
        </nav>    
        <section id="services">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p className="lead">
                  GAMEX l'expert après sinistre en transport routier est l'allié par excellence des compagnies d'assurance et de leurs clients. Si vous êtes assureurs et que vous cherchez à vous libérer des tâches fastidieuses, contactez notre équipe et voyez ce que nous pouvons faire pour vous aider.        </p>
                <button className="btn btn-primary" data-toggle="modal" data-target=".login_modal">Accéder à une présentation personnalisée</button>
                <a className="btn btn-primary " href="/expert-en-sinistre/contact">Vous n’avez pas d’accès?</a>
              </div>
            </div>
            {/*
    <hr />
    <div class="row">

      <div class="col-md-4">
        <a class="btn btn-primary" href="#pourquoi_gamex">Logistique</a>
        
      </div>
      <div class="col-md-4">
        
        <a class="btn btn-primary" href="#pourquoi_gamex">Gestion</a>
        
      </div>
      <div class="col-md-4">
        <a class="btn btn-primary" href="#pourquoi_gamex">Entreposage</a>
        
      </div>
    </div>
    */}
          </div>
        </section>
        <section id="gamex_plus">
          <div className="container marker_container">
            <div className="marker_holder">
              <div className="section_marker">Qui sommes-nous ?</div>
              <div className="pointer_left" />
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src="img/logo_groupe_gamache_fr.png" alt="Groupe Gamache" />
              </div>
              <div className="col-sm-4">
              </div>
              <div className="col-xs-12">
                <p className="lead">Le Groupe Gamache est un joueur majeur dans le marché des véhicules lourds d’occasion en Amérique du Nord depuis plus de 45 ans. Il occupe une place importante au Canada et au Nord-Est des États-Unis  avec une offre de service complète pour l’industrie. </p>
                <p className="lead">Le Groupe Gamache, c’est :</p>
                <p>
                </p><ul>
                  <li>Gamache Montréal et Centre du camion Gamache (vente/achat de poids lourds et points de services connexes à Toronto et à Champlain [New York])
                    <ul>
                      <li>G-Financement (financement, refinancement et garanties prolongées)</li>
                      <li>Pneus Gamache (vente de pneus neufs ou usagés et de jantes)</li>
                      <li>Un service de reprise de finance aux institutions spécialisées dans le financement de véhicules et d’équipements lourds</li>
                    </ul>
                  </li>
                  <li>GAMEX (exportation et vente de pièces pour poids lourds et plus grand expert en transport routier après sinistre au Canada)</li>
                </ul><p />
                <p>Nous sommes les experts poids lourds!</p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_esportation_fr.png" alt="GAMEX exportation" />
                {/*<h4>GAMEX exportation</h4>*/}
                <p>GAMEX exporte une multitude de pièces, de camions lourds usagés et de remorques dans plus de 35 pays à travers le monde.</p>
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_sinistre_fr.png" alt="GAMEX expert en sinistre" />
                {/*<h4>GAMEX expert en sinistre</h4>    */}
                <p>GAMEX l'expert après sinistre en transport routier est l'allié par excellence des compagnies d'assurance et de leurs clients.</p>
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_pieces_fr.png" alt="GAMEX pièces" />
                {/*<h4>GAMEX pièces</h4>      */}
                <p>GAMEX est le plus important fournisseur de pièces usagées de véhicules lourds pour les concessionnaires, les ateliers de réparation et les entreprises du Québec, de l'Ontario et du nord-est des États-Unis.</p>
              </div>
            </div>
            <hr />
          </div>
          {/*
  <div class="container">

      <div class="col-md-12">
        <h2>La force d'un groupe</h2>
        <p class="lead">
          GAMEX, une filiale du GROUPE GAMACHE, exporte une multitude de pièces, de camions lourds usagés et de remorques dans plus de 35 pays à travers le monde.
        </p>        
        
        
          <p>
            GAMEX fait partie du Groupe Gamache, un chef de file dans l’industrie des véhicules lourds d’occasion. Une entreprise bien établie, un service imbattable, une structure solide, du personnel qualifié et passionné, un marché dans près de 35 pays et un choix inégalé de camions et de pièces, voilà ce que vous offrent le Groupe Gamache et Gamex!
          </p>
          <p>
            Nous offrons des services clés en main aux compagnies d’assurances. Dès que l’assuré fait une réclamation auprès de son assureur, ce dernier peut communiquer avec Gamex, qui prendra en charge les équipements sinistrés dans un délai très rapide. Du remorquage des équipements endommagés à leur remise en état de fonctionnement en passant par la prise en charge de la cargaison, GAMEX s’occupe de chaque étape avec professionnalisme, rapidité et efficacité.
          </p>
      
            </div>
  </div>
  */}
        </section>
        <section className="gamex_plus">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Un service hors pair</h2>
                <p className="lead">
                  Les mécaniciens et techniciens expérimentés préparent soigneusement les pièces de camions lourds et équipements sélectionnés par la clientèle. GAMEX prend en charge tous les aspects de la logistique de transport des pièces et véhicules en minimisant les coûts.
                </p>      </div>
            </div>
          </div>
        </section>
        <section id="demo_video">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Gamex, partout <span className="text-muted">pour vous</span></h1>
                <video id="gamex_sat" poster={require("../assets/media/gamex_sat_poster.jpg")}>
                  <source src={require("../assets/media/gamex_sat_fr.mp4")} type="video/mp4" />
                  <source src={require("../assets/media/gamex_sat_fr.webm")} type="video/webm" />
                  <source src={require("../assets/media/gamex_sat_fr.ogv")} type="video/ogg" />
                </video>
                <p className="lead">
                  Que ce soit pour la logistique entourant un incident relié au transport, ou pour des besoins d'exportation de pièces, l'expertise que <strong>GAMEX</strong> a développée dans les dernières années vous assure un projet réussi, et ce, avec une tranquillité d'esprit totale.       </p>
              </div>
            </div>
          </div>
        </section>
        <section id="reussite" className="hidden-xs">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-9 col-xs-10">
                <h1 className="fr">
                  <span>Pour une intervention</span><span>réussie à 100%</span><span>un nom s'impose</span><span className="logotype">Gamex</span><span>l'expert</span><span>après sinistre</span><span>en transport routier</span>
                </h1>
                <a href="/expert-en-sinistre/contact" className="btn btn-primary btn-lg hidden-xs">Contactez-nous</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contactez-nous</a>
              </div>
            </div>
          </div>
        </section>
        <section id="pourquoi_gamex">
          <div className="container marker_container">
            <div className="flags" />
            <div className="marker_holder">
              <div className="section_marker">Expertise</div>
              <div className="pointer_left" />
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Pourquoi choisir <span className="logotype">GAMEX</span> expert<br />en sinistre?</h2>
                <p className="lead">
                  Depuis de nombreuses années, GAMEX offre des services hors pair de logistique après désastre pour véhicules lourds, bateaux, caravanes, etc. Nous sommes à votre disposition 24 heures sur 24, 7 jours sur 7.     </p>
                <hr />
                <button id="mobileDesc_btn" className="btn btn-primary visible-xs" type="button" data-toggle="collapse" data-target="#mobileDesc" aria-expanded="false" aria-controls="mobileDesc">
                  En apprendre plus     </button>
                <div className="collapse" id="mobileDesc">
                  <div className="row visible-xs">
                    <div className="col-md-12">
                      <p>
                        Que ce soit à la suite d’un accident, d’un incendie, d’une inondation ou de tout autre sinistre, GAMEX prend les équipements en main et s’occupe de tout, du début jusqu’à la fin.
                      </p>
                      <blockquote>
                        L’importance d’une intervention rapide et bien préparée peut souvent faire la différence pour réduire votre perte.
                      </blockquote>
                      <p>
                        Peu importe les dommages subis par les équipements, nous nous soucions de votre entière satisfaction.
                      </p>
                      <p>
                        GAMEX est là pour vous, 24 heures sur 24, 7 jours sur 7.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row hidden-xs">
                  <div className="col-md-12">
                    <p>
                      Que ce soit à la suite d’un accident, d’un incendie, d’une inondation ou de tout autre sinistre, GAMEX prend les équipements en main et s’occupe de tout, du début jusqu’à la fin.
                    </p>
                    <blockquote>
                      L’importance d’une intervention rapide et bien préparée peut souvent faire la différence pour réduire votre perte.
                    </blockquote>
                    <p>
                      Peu importe les dommages subis par les équipements, nous nous soucions de votre entière satisfaction.
                    </p>
                    <p>
                      GAMEX est là pour vous, 24 heures sur 24, 7 jours sur 7.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*
    <div class="row">
      <div class="col-md-12">
        <a href="#contact" onclick="lift_contact();" class="btn btn-primary">Contactez-nous</a>
      </div>
    </div>
    
    */}
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h3>Logistique</h3>
                <p>
                  GAMEX s’occupe de vous! Nous prenons en main vos dossiers et gérons leur logistique au moment où vous nous contactez. Nous prenons en charge vos dossiers jusqu’au règlement.   
                </p>
              </div>
              <div className="col-md-4">
                <h3>Gestion</h3>
                <p>
                  Dès que votre cas se retrouve entre nos mains, vous pouvez garder l’esprit tranquille en ce qui concerne votre cargaison, vos documents et bien plus! Quelle que soit la suite des événements, nous nous en occuperons.   
                </p>
              </div>
              <div className="col-md-4">
                <h3>Entreposage</h3>
                <p>
                  Véhicules et cargaisons sont maintenant en sécurité dans nos installations. Nous avons l'espace nécessaire, et ce, pour tout le temps que vous en aurez besoin, sans frais supplémentaires.   
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="ramassage_cargaison">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h3>Ramassage de cargaison</h3>
                <p>Nous gérons et entreposons votre cargaison lors d’un incident. Nous nous occupons de la logistique de votre dossier et du règlement de vos documents.
                </p>
              </div>
              <div className="col-md-6">
                <h3>Récupération de véhicule lourd</h3>
                <p>Nous remisons votre véhicule lourd ou votre matériel roulant accidenté jusqu’au règlement de votre dossier.  Nous vous simplifions la logistique et les démarches.</p>
              </div>
            </div>
          </div>
        </section>
        <section id="faq">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Questions fréquentes</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>Pouvez-vous prendre en charge les cargaisons réfrigérées ?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  Bien sûr ! Nous pouvons non seulement récupérer les cargaisons réfrigérées ou surgelées, mais nous pouvons aussi les entreposer jusqu'à la fin du processus, ou même, les livrer au destinataire comme si rien ne s'était produit.        </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>Qu'arrive-t-il lors d'un accident aux États-Unis ?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  Nous nous déplaçons sur le lieu de l'accident même et nous récupérons le véhicule accidenté ainsi que sa cargaison. Une fois de retour à nos installations nous pouvons alors poursuivre avec la suite des procédures.        </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>Qu'arrivera-t-il une fois la cargaison récupérée ?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  Tout dépend de vos besoins. Si un cas exige une livraison au destinataire, nous livrons la cargaison. Si nous devons nous départir de la marchandise, nous communiquons avec le fournisseur pour obtenir un avis de destruction. Nous pouvons également garder la marchandise dans nos entrepôts jusqu'à nouvel ordre.        </div>
              </div>
            </div>
          </div>
        </section>
        {/*
<section>
  
  <div class="container">
    
    <div class="row">
      
      <div class="col-md-12">
        <h3>N'hésitez pas à nous joindre pour mieux connaître nos différents services et pour obtenir de l'information sur nos différents tarifs. Consultez également <a href='https://expertensinistre.groupegamache.com/gamex.php#faq'>notre FAQ</a>: elle répondra certainement à vos interrogations.</h3>
        <a href="#contact" onclick="lift_contact();" class="btn btn-primary hidden-xs">Contactez-nous</a>
        <a href="tel:18666354402" class="btn btn-primary btn-lg visible-xs">Contactez-nous</a>

      </div>
    </div>
  </div>
</section>
*/}
        <div className="container">
          <div className="row">
            <hr />
            <div className="row last_row">
              <div className="col-md-12">
                <h3>N'hésitez pas à nous joindre pour mieux connaître nos différents services et pour obtenir de l'information sur nos différents tarifs. Consultez également notre FAQ: elle répondra certainement à vos interrogations.</h3>
                <a href="/expert-en-sinistre/contact" className="btn btn-primary hidden-xs">Contactez-nous</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contactez-nous</a>
              </div>
            </div>
          </div>
        </div>
        <footer className>
          <div className="container">
            <div className="col-md-12">
              <h1><span className="logotype">GAMEX</span> Expert en sinistre</h1>
            </div>
          </div>
        </footer>
        <div className="modal fade login_modal" tabIndex={-1} role="dialog" aria-labelledby="login_modal">
          <div className="modal-dialog modal-sm">
            <form action="modal_login.php" method="post">
              <div className="modal-content">
                <h1>
                  Veuillez-vous connecter.    </h1>
                <p className="lead">
                  Vous devez être connecté pour accéder à cette section.    </p>
                <div className="form-group">
                  <input className="form-control" type="text" name="email" placeholder="Courriel" required />
                </div>
                <div className="form-group">
                  <input className="form-control" type="password" name="pass" placeholder="Mot de passe" required />
                </div>
                <div className="form-group">
                  <button type="submit" name="btn-login" className="btn btn-primary">Se connecter</button>
                  <hr />
                  <a className href="/expert-en-sinistre/contact">Vous n’avez pas d’accès?</a>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Act-On Tracking */}
        {/* END Act-On */}
      </div>










      )
  }
}


// WEBPACK FOOTER //
// ./src/components/Fr.js